import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Grupos/Permissões',
    path: '/gestaousuarios/grupospermissoes',
    name: 'grupo_usuario',
    component: () => import('@/views/gestaousuarios/grupospermissoes/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.GESTAO_PERMISSOES_MENU_900100101],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Grupos/Permissões',
    path: '/gestaousuarios/grupospermissoes/cadastro/:id?',
    parent: 'grupo_usuario',
    name: 'grupospermissoes_create',
    component: () => import('@/views/gestaousuarios/grupospermissoes/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.GESTAO_PERMISSOES_MENU_900100101],
    },
    goesToMenu: false,
  },
];
